import { render, staticRenderFns } from "./DataTable_report.vue?vue&type=template&id=9f1cfcac&scoped=true&"
import script from "./DataTable_report.vue?vue&type=script&lang=js&"
export * from "./DataTable_report.vue?vue&type=script&lang=js&"
import style0 from "./DataTable_report.vue?vue&type=style&index=0&id=9f1cfcac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1cfcac",
  null
  
)

export default component.exports